(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lnpdInitialized === 'true') return;
    root.dataset.lnpdInitialized = 'true';

    var form = root.querySelector('.lnpd-form');
    var variantInput = root.querySelector('[data-lnpd-variant-id]');
    var variantsNode = root.querySelector('[data-lnpd-variants]');
    var addButton = root.querySelector('[data-lnpd-add]');
    var addLabel = root.querySelector('[data-lnpd-add-label]');
    var priceNode = root.querySelector('[data-lnpd-price]');
    var compareNode = root.querySelector('[data-lnpd-compare]');
    var stockNode = root.querySelector('[data-lnpd-stock]');
    var stickyPrice = root.querySelector('[data-lnpd-sticky-price]');
    var stickyButton = root.querySelector('[data-lnpd-sticky-submit]');
    var sizing = root.querySelector('product-sizing, product-measurement-sizing');
    var dynamicCheckout = root.querySelector('.lnpd-dynamic');
    var quantity = root.querySelector('[data-lnpd-quantity] input');
    var quantityMinus = root.querySelector('[data-lnpd-quantity-minus]');
    var quantityPlus = root.querySelector('[data-lnpd-quantity-plus]');
    var cartUpdateUnsubscriber = null;
    var cartQuantityAbortController = null;
    var cartQuantityRequestId = 0;
    var cartQuantityRequestTimeout = null;
    var purchaseObserver = null;
    var variants = [];
    var labels = {
      add: root.dataset.addLabel || 'Add to cart',
      soldOut: root.dataset.soldOutLabel || 'Sold out',
      unavailable: root.dataset.unavailableLabel || 'Unavailable',
      chooseSize: root.dataset.chooseSizeLabel || 'Choose a size to continue',
      added: root.dataset.addedLabel || 'Added to cart'
    };

    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    var currentVariant = variants.find(function (variant) {
      return String(variant.id) === String(root.dataset.selectedVariantId);
    }) || variants[0];
    var selections = currentVariant ? currentVariant.options.slice() : [];

    function moneyText(variant) {
      return variant && variant.priceText ? variant.priceText : '';
    }

    function sizingActionLabel() {
      return sizing && sizing.dataset.customOnly === 'true' && sizing.dataset.statusPending
        ? sizing.dataset.statusPending : labels.chooseSize;
    }

    function syncSticky() {
      if (!stickyButton) return;
      var missingVariant = !currentVariant;
      var unavailable = missingVariant || !currentVariant.available;
      var quantityLocked = !quantityIsValid();
      stickyButton.disabled = unavailable || quantityLocked;
      if (missingVariant) {
        stickyButton.textContent = labels.unavailable;
      } else if (unavailable) {
        stickyButton.textContent = labels.soldOut;
      } else if (root.dataset.sizingRequired === 'true' && !sizingIsValid()) {
        stickyButton.textContent = sizingActionLabel();
      } else {
        stickyButton.textContent = labels.add;
      }
    }

    function sizingIsValid() {
      if (root.dataset.sizingRequired !== 'true') return true;
      if (!sizing) return false;
      if (typeof sizing.isValid === 'function') {
        try { return sizing.isValid(); } catch (error) {}
      }
      return Boolean(sizing.querySelector('[data-size-radio]:checked:not([disabled])'));
    }

    function quantityIsValid() {
      if (!quantity) return true;
      var value = Number(quantity.value);
      return Number.isFinite(value)
        && Number.isInteger(value)
        && value >= 1
        && quantity.checkValidity();
    }

    function setBooleanAttribute(element, name, enabled) {
      if (!element) return;
      if (enabled && !element.hasAttribute(name)) element.setAttribute(name, '');
      if (!enabled && element.hasAttribute(name)) element.removeAttribute(name);
    }

    function syncPurchaseState() {
      var missingVariant = !currentVariant;
      var unavailable = missingVariant || !currentVariant.available;
      var sizingLocked = root.dataset.sizingRequired === 'true' && !sizingIsValid();
      var quantityLocked = !quantityIsValid();
      if (form) form.dataset.quantityBlocked = String(quantityLocked);

      if (addButton) {
        if (unavailable && addButton.dataset.variantLocked !== 'true') addButton.dataset.variantLocked = 'true';
        else if (!unavailable && addButton.dataset.variantLocked) delete addButton.dataset.variantLocked;
        if (sizingLocked && addButton.dataset.sizingLocked !== 'true') addButton.dataset.sizingLocked = 'true';
        else if (!sizingLocked && addButton.dataset.sizingLocked) delete addButton.dataset.sizingLocked;
        if (quantityLocked && addButton.dataset.quantityRuleLocked !== 'true') addButton.dataset.quantityRuleLocked = 'true';
        else if (!quantityLocked && addButton.dataset.quantityRuleLocked) delete addButton.dataset.quantityRuleLocked;

        var shouldDisable = unavailable || sizingLocked || quantityLocked;
        if (addButton.disabled !== shouldDisable) addButton.disabled = shouldDisable;
        if (shouldDisable) addButton.setAttribute('aria-disabled', 'true');
        else addButton.removeAttribute('aria-disabled');
        var nextAddLabel = missingVariant ? labels.unavailable : (unavailable ? labels.soldOut : (sizingLocked ? sizingActionLabel() : labels.add));
        if (addLabel && addLabel.textContent !== nextAddLabel) addLabel.textContent = nextAddLabel;
      }

      if (dynamicCheckout) {
        var checkoutLocked = unavailable || sizingLocked || quantityLocked;
        dynamicCheckout.classList.toggle('ps-checkout-locked', checkoutLocked);
        dynamicCheckout.setAttribute('aria-disabled', String(checkoutLocked));
        dynamicCheckout.inert = checkoutLocked;
        setBooleanAttribute(dynamicCheckout, 'data-sizing-checkout-locked', sizingLocked);
        if (quantityLocked) dynamicCheckout.dataset.quantityRuleLocked = 'true';
        else if (dynamicCheckout.dataset.quantityRuleLocked) delete dynamicCheckout.dataset.quantityRuleLocked;
        dynamicCheckout.querySelectorAll('button').forEach(function (button) {
          button.disabled = checkoutLocked;
        });
      }

      syncSticky();
    }

    function focusVariantMedia(variant) {
      if (!variant || !variant.featuredMediaId || window.matchMedia('(min-width: 768px)').matches) return;
      var media = root.querySelector('[data-media-id="' + variant.featuredMediaId + '"]');
      if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    function syncQuantityButtons() {
      if (!quantity) return;
      var value = Number(quantity.value);
      var minimum = Number(quantity.min || 1);
      var maximum = quantity.max === '' ? null : Number(quantity.max);
      if (quantityMinus) quantityMinus.disabled = !Number.isFinite(value) || value <= minimum;
      if (quantityPlus) quantityPlus.disabled = maximum !== null && Number.isFinite(maximum) && value >= maximum;
    }

    function applyQuantityRule(variant) {
      if (!quantity) return;
      var rule = variant && variant.quantityRule ? variant.quantityRule : {};
      var ruleMinimum = Number(rule.min) || 1;
      var increment = Number(rule.increment) || 1;
      var cartQuantity = Number(rule.cartQuantity) || 0;
      var maximum = rule.max === null || rule.max === undefined || rule.max === ''
        ? null
        : Math.max(0, Number(rule.max) - cartQuantity);
      var minimum = ruleMinimum;
      if (maximum !== null && maximum > 0) minimum = Math.min(minimum, maximum);
      if (cartQuantity >= ruleMinimum) minimum = Math.min(minimum, increment);
      quantity.min = String(maximum === 0 ? ruleMinimum : minimum);
      quantity.step = String(increment);
      if (maximum === null) quantity.removeAttribute('max');
      else quantity.max = String(maximum);
      quantity.value = String(maximum === 0 ? 0 : minimum);
      syncQuantityButtons();
      syncPurchaseState();
    }

    function applyCartSnapshot(cart) {
      if (!cart || !Array.isArray(cart.items)) return false;
      var cartQuantitiesByVariant = cart.items.reduce(function (quantities, item) {
        var variantId = item && item.variant_id;
        if (variantId === null || variantId === undefined) return quantities;
        var key = String(variantId);
        quantities[key] = (quantities[key] || 0) + (Number(item.quantity) || 0);
        return quantities;
      }, {});
      document.querySelectorAll('.lnmm-cart__count').forEach(function (count) {
        count.textContent = cart.item_count;
      });
      document.querySelectorAll('.lnmm-cart').forEach(function (link) {
        link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
      });
      variants.forEach(function (variant) {
        if (!variant.quantityRule) return;
        variant.quantityRule.cartQuantity = cartQuantitiesByVariant[String(variant.id)] || 0;
      });
      if (currentVariant && currentVariant.quantityRule) applyQuantityRule(currentVariant);
      return true;
    }

    function cancelCartQuantityRefresh() {
      cartQuantityRequestId += 1;
      if (cartQuantityAbortController) cartQuantityAbortController.abort();
      if (cartQuantityRequestTimeout) window.clearTimeout(cartQuantityRequestTimeout);
      cartQuantityAbortController = null;
      cartQuantityRequestTimeout = null;
    }

    function refreshCartQuantity() {
      var requestId = ++cartQuantityRequestId;
      if (cartQuantityAbortController) cartQuantityAbortController.abort();
      if (cartQuantityRequestTimeout) window.clearTimeout(cartQuantityRequestTimeout);
      var abortController = new AbortController();
      cartQuantityAbortController = abortController;
      cartQuantityRequestTimeout = window.setTimeout(function () {
        if (requestId === cartQuantityRequestId) abortController.abort();
      }, 20000);

      return window.fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        signal: abortController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to refresh the cart quantity.');
          return response.json();
        })
        .then(function (cart) {
          if (requestId !== cartQuantityRequestId || !root.isConnected) return;
          applyCartSnapshot(cart);
        })
        .catch(function (error) {
          if (requestId !== cartQuantityRequestId || error.name === 'AbortError') return;
          console.error(error);
        })
        .finally(function () {
          if (requestId !== cartQuantityRequestId) return;
          if (cartQuantityRequestTimeout) window.clearTimeout(cartQuantityRequestTimeout);
          cartQuantityRequestTimeout = null;
          if (cartQuantityAbortController === abortController) cartQuantityAbortController = null;
        });
    }

    function handleCartUpdate(response) {
      var cart = response && response.cart;
      var isFullCartSnapshot = cart
        && Array.isArray(cart.items)
        && Number.isFinite(Number(cart.item_count));
      if (isFullCartSnapshot) {
        cancelCartQuantityRefresh();
        applyCartSnapshot(cart);
      } else {
        refreshCartQuantity();
      }
    }

    function updateVariant(variant, updateUrl) {
      currentVariant = variant || null;
      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (form) form.dataset.variantAvailable = 'false';
        if (addButton) {
          addButton.disabled = true;
          addButton.dataset.variantLocked = 'true';
          addButton.setAttribute('aria-disabled', 'true');
        }
        if (addLabel) addLabel.textContent = labels.unavailable;
        if (stockNode) {
          stockNode.classList.add('is-soldout');
          stockNode.lastChild.textContent = ' ' + labels.unavailable;
        }
        document.dispatchEvent(new CustomEvent('variant:changed', {
          detail: { sectionId: root.dataset.sectionId, variant: null }
        }));
        syncPurchaseState();
        return;
      }

      if (variantInput) {
        var variantChanged = String(variantInput.value) !== String(variant.id);
        variantInput.value = variant.id;
        if (variantChanged) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (form) form.dataset.variantAvailable = String(Boolean(variant.available));
      applyQuantityRule(variant);
      if (priceNode) priceNode.textContent = moneyText(variant);
      if (stickyPrice) stickyPrice.textContent = moneyText(variant);
      if (compareNode) {
        var showCompare = variant.compareAtPrice > variant.price;
        compareNode.textContent = showCompare ? variant.compareAtText : '';
        compareNode.classList.toggle('is-hidden', !showCompare);
      }
      if (stockNode) {
        stockNode.classList.toggle('is-soldout', !variant.available);
        stockNode.lastChild.textContent = variant.available ? ' In stock' : ' ' + labels.soldOut;
      }
      if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.soldOut;

      if (addButton) {
        if (!variant.available) {
          addButton.disabled = true;
          addButton.dataset.variantLocked = 'true';
          addButton.setAttribute('aria-disabled', 'true');
        } else if (!sizing) {
          addButton.disabled = false;
          delete addButton.dataset.variantLocked;
          addButton.removeAttribute('aria-disabled');
        }
      }

      document.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { sectionId: root.dataset.sectionId, variant: variant }
      }));

      if (updateUrl && variant.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }
      focusVariantMedia(variant);
      window.setTimeout(syncPurchaseState, 0);
    }

    root.querySelectorAll('[data-lnpd-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        var position = Number(button.dataset.optionPosition) - 1;
        selections[position] = button.dataset.value;
        var fieldset = button.closest('.lnpd-option');
        fieldset.querySelectorAll('[data-lnpd-option]').forEach(function (sibling) {
          sibling.setAttribute('aria-pressed', String(sibling === button));
        });
        var selectedLabel = fieldset.querySelector('[data-lnpd-selected-option]');
        if (selectedLabel) selectedLabel.textContent = button.dataset.value;
        var match = variants.find(function (variant) {
          return variant.options.every(function (value, index) { return value === selections[index]; });
        });
        updateVariant(match, true);
      });
    });

    root.querySelectorAll('[data-lnpd-accordion]').forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', String(!expanded));
        button.closest('.lnpd-accordion').classList.toggle('is-open', !expanded);
        button.querySelector('span').textContent = expanded ? '+' : '−';
        if (panel) panel.hidden = expanded;
      });
    });

    quantityMinus?.addEventListener('click', function () {
      if (!quantity) return;
      quantity.stepDown();
      syncQuantityButtons();
    });
    quantityPlus?.addEventListener('click', function () {
      if (!quantity) return;
      quantity.stepUp();
      syncQuantityButtons();
    });
    quantity?.addEventListener('input', function () {
      if (quantity.dataset.quantityValidationOwned === 'true') {
        quantity.setCustomValidity('');
        delete quantity.dataset.quantityValidationOwned;
      }
      syncQuantityButtons();
      syncPurchaseState();
    });

    var wishlistButton = root.querySelector('[data-lnpd-wishlist]');
    if (wishlistButton) {
      var wishlistKey = 'lunarness:wishlist:' + root.dataset.productId;
      try { wishlistButton.setAttribute('aria-pressed', String(localStorage.getItem(wishlistKey) === 'true')); } catch (error) {}
      wishlistButton.addEventListener('click', function () {
        var next = wishlistButton.getAttribute('aria-pressed') !== 'true';
        wishlistButton.setAttribute('aria-pressed', String(next));
        wishlistButton.setAttribute('aria-label', next ? 'Remove from wishlist' : 'Add to wishlist');
        try { localStorage.setItem(wishlistKey, String(next)); } catch (error) {}
      });
    }

    var gallery = root.querySelector('[data-lnpd-gallery]');
    var galleryCount = root.querySelector('[data-lnpd-gallery-count]');
    if (gallery && galleryCount) {
      var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-lnpd-media]'));
      var ticking = false;
      gallery.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          galleryCount.textContent = (Math.min(index + 1, mediaItems.length)) + ' / ' + mediaItems.length;
          ticking = false;
        });
      }, { passive: true });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available) return;
        syncPurchaseState();
        if (addButton && addButton.disabled) {
          var target = sizing || root.querySelector('.lnpd-options');
          target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () {
            (target?.querySelector('[data-size-radio]:not([disabled]), [data-custom-required]:not([disabled]), [data-lnpd-option]:not([disabled])') || target?.querySelector('input:not([disabled]), button:not([disabled])'))?.focus({ preventScroll: true });
          }, 350);
          return;
        }
        if (form && addButton) form.requestSubmit(addButton);
      });
    }

    if (addButton) {
      purchaseObserver = new MutationObserver(syncPurchaseState);
      purchaseObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled', 'data-sizing-locked', 'data-quantity-rule-locked', 'data-variant-locked'] });
    }
    form?.addEventListener('submit', function (event) {
      syncPurchaseState();
      if (root.dataset.sizingRequired !== 'true' || sizingIsValid()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof sizing?.validate === 'function') sizing.validate({ focus: true });
      sizing?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    function handleProductAdded(event) {
      var addedPayload = event.detail && event.detail.product ? event.detail.product : {};
      var addedItems = Array.isArray(addedPayload.items) ? addedPayload.items : [addedPayload];
      var currentVariantWasAdded = false;
      addedItems.forEach(function (item) {
        var itemVariantId = item && (item.variant_id || item.id);
        var addedQuantity = Number(item && item.quantity) || 0;
        if (itemVariantId === null || itemVariantId === undefined || addedQuantity <= 0) return;
        var addedVariant = variants.find(function (variant) {
          return String(variant.id) === String(itemVariantId);
        });
        if (!addedVariant || !addedVariant.quantityRule) return;
        addedVariant.quantityRule.cartQuantity = (Number(addedVariant.quantityRule.cartQuantity) || 0) + addedQuantity;
        if (currentVariant && String(currentVariant.id) === String(addedVariant.id)) currentVariantWasAdded = true;
      });
      if (currentVariantWasAdded) applyQuantityRule(currentVariant);
      if (stickyButton) {
        stickyButton.textContent = labels.added;
        window.setTimeout(syncSticky, 1400);
      }
      refreshCartQuantity();
    }

    document.addEventListener('product-ajax:added', handleProductAdded);
    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      cartUpdateUnsubscriber = window.MinimogEvents.subscribe(
        window.MinimogTheme.pubSubEvents.cartUpdate,
        handleCartUpdate
      );
    }
    function handleSectionUnload(event) {
      if (event.target !== root && !event.target.contains(root)) return;
      cartUpdateUnsubscriber?.();
      cancelCartQuantityRefresh();
      purchaseObserver?.disconnect();
      document.removeEventListener('product-ajax:added', handleProductAdded);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    }
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    root.addEventListener('change', function () { window.setTimeout(syncPurchaseState, 0); });
    updateVariant(currentVariant, false);
    syncPurchaseState();
    window.setTimeout(syncPurchaseState, 0);
    window.setTimeout(syncPurchaseState, 250);
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-lnpd]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
